import script from "./rohsConformityDeclarationsList.vue?vue&type=script&setup=true&lang=js"
export * from "./rohsConformityDeclarationsList.vue?vue&type=script&setup=true&lang=js"

import "./rohsConformityDeclarationsList.vue?vue&type=style&index=0&id=c1a9a010&lang=scss"

const __exports__ = script;

export default __exports__